import {
  DEFAULT_PAGER,
  FilterType,
  TDataTablePager,
} from '@monetize/types/common';
import { useMemo, useState } from 'react';
import { useInvoiceListByAccount } from '../../api/accountsService';
import {
  buildFilterParamsRequestObject,
  transformTableFilterValue,
} from '../../utils';

export const useInvoices = (accountId: string, billGroupId?: string) => {
  const [filters, setFilters] = useState<FilterType[]>([]);
  const [pager, setPager] = useState<TDataTablePager>(DEFAULT_PAGER);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const filterParams = useMemo(() => {
    const params = buildFilterParamsRequestObject(
      transformTableFilterValue(filters, ['lastSent']),
      searchTerm,
      'id',
    );
    return params;
  }, [filters, searchTerm]);

  const {
    isLoading,
    isFetched,
    isRefetching,
    data: invoices,
    isError,
    error,
    refetch,
  } = useInvoiceListByAccount(
    {
      accountId,
      config: pager,
      filters: billGroupId ? { ...filterParams, billGroupId } : filterParams,
    },
    { meta: { showErrorToast: true } },
  );

  const onResetFilter = () => {
    setFilters([]);
    setSearchTerm('');
  };

  return {
    pager,
    setPager,
    filters,
    setFilters,
    onResetFilter,
    isLoading: isLoading || (isRefetching && !isFetched),
    invoices,
    searchTerm,
    setSearchTerm,
    isError,
    error,
    refetch,
  };
};
